import React, { createContext, useContext, useState } from 'react';
import { LinkBuildingPartner } from '@/hooks/useLinkBuildingPartners';

interface LinkBuildingPartnerContextType {
  isOpen: boolean;
  editingPartner: LinkBuildingPartner | null;
  openAddPartner: () => void;
  openEditPartner: (partner: LinkBuildingPartner) => void;
  closePartnerDialog: () => void;
}

const LinkBuildingPartnerContext = createContext<LinkBuildingPartnerContextType | undefined>(undefined);

export const LinkBuildingPartnerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingPartner, setEditingPartner] = useState<LinkBuildingPartner | null>(null);

  const openAddPartner = () => {
    setEditingPartner(null);
    setIsOpen(true);
  };

  const openEditPartner = (partner: LinkBuildingPartner) => {
    setEditingPartner(partner);
    setIsOpen(true);
  };

  const closePartnerDialog = () => {
    setIsOpen(false);
    setEditingPartner(null);
  };

  return (
    <LinkBuildingPartnerContext.Provider 
      value={{ 
        isOpen, 
        editingPartner, 
        openAddPartner, 
        openEditPartner, 
        closePartnerDialog 
      }}
    >
      {children}
    </LinkBuildingPartnerContext.Provider>
  );
};

export const useLinkBuildingPartner = () => {
  const context = useContext(LinkBuildingPartnerContext);
  if (context === undefined) {
    throw new Error('useLinkBuildingPartner must be used within a LinkBuildingPartnerProvider');
  }
  return context;
};
